import { useFirstScreenAB } from './firstScreen/useFirstScreenAb';
// showFlash AB实验 https://abtest-sgp.corp.kuaishou.com/ab2#/experiment/analysis/5846/detail?tab=2&isShared=true&docType=12

export function useShowFlash() {
    const state = useFirstScreenAB();

    return {
        showFlash: !!state.if_detail_product_list_show_flash_sale,
    };
}
